import { useNavigate } from "react-router-dom";
import { aboutHero } from "../../assets";
import { Fade } from "react-awesome-reveal";
import { trackEvent } from "../../helpers";
import {
  PageWrapper,
  HeroSection,
  HeroContainer,
  HeroContent,
  HeroTagline,
  HeroTitle,
  HeroDescription,
  HeroButtons,
  PrimaryButton,
  SecondaryButton,
  HeroImageWrapper,
  HeroImageCircle,
  HeroImage,
  HeroStatsSection,
  StatItem,
  StatValue,
  StatLabel,
} from "./home.styles";
import { Background } from "../../components/background";

export const Home = () => {
  const navigate = useNavigate();

  const navigateAndTrack = (path: string, event: string) => {
    navigate(path);
    trackEvent(event);
  };

  return (
    <PageWrapper>
      <Background />

      {/* Hero Section */}
      <HeroSection>
        <HeroContainer>
          <HeroContent>
            <Fade triggerOnce>
              <HeroTagline>TECHNICAL DELIVERY EXPERT</HeroTagline>
              <HeroTitle>
                Bridging the gap between <em>roadmap and reality.</em>
              </HeroTitle>
            </Fade>
            <Fade delay={100} triggerOnce>
              <HeroDescription>
                I build AI integrations, MVPs and enterprise-scale systems that keep up as your product grows.
              </HeroDescription>
            </Fade>
            <Fade delay={200} triggerOnce>
              <HeroButtons>
                <PrimaryButton onClick={() => navigateAndTrack("/contact", "Home - Contact click")}>
                  Book a discovery call
                </PrimaryButton>
                <SecondaryButton onClick={() => navigateAndTrack("/services", "Home - Services click")}>
                  Explore services
                </SecondaryButton>
              </HeroButtons>
            </Fade>

            {/* Stats Section */}
            <HeroStatsSection style={{ marginTop: '32px', gridColumn: 'unset' }}>
              <Fade delay={250} triggerOnce>
                <StatItem
                  onClick={() => navigateAndTrack("/about", "Home - Experience stat click")}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigateAndTrack("/about", "Home - Experience stat click");
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  style={{ cursor: 'pointer' }}
                >
                  <StatValue>6 years</StatValue>
                  <StatLabel>BUILDING AI-POWERED SOFTWARE AT SCALE</StatLabel>
                </StatItem>
              </Fade>
              <Fade delay={300} triggerOnce>
                <StatItem
                  onClick={() => {
                    window.open('https://bragbooq.com', '_blank');
                    trackEvent("Home - Bragbooq stat click");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      window.open('https://bragbooq.com', '_blank');
                      trackEvent("Home - Bragbooq stat click");
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  style={{ cursor: 'pointer' }}
                >
                  <StatValue>Founder</StatValue>
                  <StatLabel>BRAGBOOQ</StatLabel>
                </StatItem>
              </Fade>
              <Fade delay={350} triggerOnce>
                <StatItem>
                  <StatValue>Audits</StatValue>
                  <StatLabel>ARCHITECTURE & DELIVERY REVIEWS</StatLabel>
                </StatItem>
              </Fade>
              <Fade delay={400} triggerOnce>
                <StatItem
                  onClick={() => navigateAndTrack("/the-guide", "Home - Author stat click")}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigateAndTrack("/the-guide", "Home - Author stat click");
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  style={{ cursor: 'pointer' }}
                >
                  <StatValue>Author</StatValue>
                  <StatLabel>THE UNHINGED GUIDE TO BREAKING INTO TECH</StatLabel>
                </StatItem>
              </Fade>
            </HeroStatsSection>
          </HeroContent>

          <HeroImageWrapper>
            <Fade delay={300} triggerOnce>
              <HeroImageCircle>
                <HeroImage src={aboutHero} alt="Renée Louise - Technical Delivery Expert" />
              </HeroImageCircle>
            </Fade>
          </HeroImageWrapper>
        </HeroContainer>
      </HeroSection>
    </PageWrapper>
  );
};
